import { appHttpClient } from "../../installations/http/axiosInterfaces";

export const addOrder = (data) => {
  return appHttpClient.post(`/Order`, data);
};

export const updateOrder = (orderId, data) => {
  return appHttpClient.put(`/Order/${orderId}`, data);
};

export const deleteOrder = (orderId) => {
  return appHttpClient.delete(`/Order/${orderId}`);
};

export const getOrderById = (orderId) => {
  return appHttpClient.get(`/Order/${orderId}`);
};

export const getOrders = () => {
  return appHttpClient.get(`/Order`);
};

export const updateOrderPaymentSuccess = (paymentData) => {
  return appHttpClient.post(`/Order/Payment/Success`, paymentData);
};

const orderService = {
  addOrder,
  updateOrder,
  deleteOrder,
  getOrderById,
  getOrders,
  updateOrderPaymentSuccess
};

export default orderService;
